import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import DocumentClaimsChunk from '@Components/Results/documents/DocumentClaimsChunk';
import { Card } from '@els/els-react--card';

function DocumentClaims({ closeClick, claimsText }) {
  const handleClose = () => {
    const event = new CustomEvent('documentSectionClosed', {
      detail: { closedSection: 'claimsExpanded', focusNext: true },
    });
    document.dispatchEvent(event);
    closeClick();
  };

  return (
    <Card
      data-section="claimsExpanded"
      id="claimsExpanded-content"
      tabIndex="-1"
      role="region"
      aria-labelledby="claimsExpanded-heading"
      className="result-detail-panel u-els-margin-top-1o2">
      <div className="result-detail-panel-wrapper u-els-display-flex">
        <h4 id="claimsExpanded-heading" className="u-els-margin-right-1o2 u-els-font-family-bold result-detail-panel-wrapper-heading">
          Claims:
        </h4>
        <div className="u-els-display-flex">
          <DocumentClaimsChunk chunk={claimsText} />
          <ButtonWithIcon
            data-e2e="e2e-claims-close"
            type="link"
            iconOnly
            linkIconSize="s"
            linkOptions={['navigation']}
            sprite="Close"
            className="result-detail-panel-wrapper-close e2e-close"
            data-automationid="sub-menu-close"
            onClick={handleClose}>
            close
          </ButtonWithIcon>
        </div>
      </div>
    </Card>
  );
}

DocumentClaims.propTypes = {
  claimsText: PropTypes.string.isRequired,
  closeClick: PropTypes.func.isRequired,
};

export default DocumentClaims;
